import { requests } from './baseServices'

export const TimesheetServices = {       
    saveHours: (activityHours) => requests.put(`api/timesheet/updateHours`, activityHours),
    setMonthPending: (months) => requests.put(`api/timesheet/month/pending`, months),
    setMonthValidated: (months) => requests.put(`api/timesheet/month/validate`, months),
    setMonthRejected: (months) => requests.put(`api/timesheet/month/reject`, months),
    setMonthFinalized: (months) => requests.put(`api/timesheet/month/finalize`, months),    
    getDevsMonths: (devId, month) => requests.get(`api/timesheet/months/${devId}/${month}`),
    getDevs: () => requests.get(`api/timesheet/devs`),
    getAvailableMonths: () => requests.get(`api/timesheet/months/available`),
    getDevsMonth: (filter) => requests.get(`api/timesheet/month/${filter}`),
    getDevMonth: (devId, month, year) => requests.get(`api/timesheet/month/${devId}/${month}/${year}`),
    updateDate: (month) => requests.put(`api/timesheet/month/date`, month),
    setFinished: (month) => requests.put(`api/timesheet/month/finish`, month),

};